import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { HTML } from '@xsite-ui/common.html';
import i18next from 'i18next';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import _defineProperty$1 from '@babel/runtime/helpers/esm/defineProperty';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { b as buildFeaturesReplacementMap } from './feature-replacements-7f2d56cc.esm.js';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var countryMap = {
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua And Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia And Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, Democratic Republic',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: "Cote D'Ivoire",
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island & Mcdonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic Of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle Of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KR: 'Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyan Arab Jamahiriya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States Of',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  AN: 'Netherlands Antilles',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory, Occupied',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthelemy',
  SH: 'Saint Helena',
  KN: 'Saint Kitts And Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre And Miquelon',
  VC: 'Saint Vincent And Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome And Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia And Sandwich Isl.',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard And Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad And Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks And Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UM: 'United States Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis And Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe'
};

var monthNamesEnglish = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var monthNamesFrench = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
var monthNamesRomanian = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];
var monthNamesNetherlands = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
var monthNamesArabic = ['كانون الثاني', 'شباط', 'آذار', 'نيسان', 'أيار', 'حزيران', 'تموز', 'آب', 'أيلول', 'تشرين الأول', 'تشرين الثاني', 'كانون الأول'];
var monthNamesSpanish = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubure', 'Noviembre', 'Diciembre'];
var monthNamesPortuguese = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
var monthNamesItalian = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
var monthNamesGerman = ['Januar', 'Februar', 'März', 'April', 'Mai ', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
var monthNamesRussian = ['январь', 'февраль', 'Март', 'апрель', 'Май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'Декабрь'];
var monthNamesDanish = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
var monthNamesTurkish = ['ocak', 'şubat', 'mart', 'nisan', 'mayıs', 'haziran', 'temmuz', 'ağustos', 'ezlül', 'ekim', 'kasım', 'aralık'];
var monthNamesSweden = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'];
var monthNamesByLanguage = {
  'en-GB': monthNamesEnglish,
  en: monthNamesEnglish,
  'fr-FR': monthNamesFrench,
  fr: monthNamesFrench,
  'ro-RO': monthNamesRomanian,
  ro: monthNamesRomanian,
  'nl-NL': monthNamesNetherlands,
  nl: monthNamesNetherlands,
  'ar-AR': monthNamesArabic,
  ar: monthNamesArabic,
  'ru-RU': monthNamesRussian,
  ru: monthNamesRussian,
  es: monthNamesSpanish,
  'es-ES': monthNamesSpanish,
  'it-IT': monthNamesItalian,
  it: monthNamesItalian,
  de: monthNamesGerman,
  'de-DE': monthNamesGerman,
  br: monthNamesPortuguese,
  'br-BR': monthNamesPortuguese,
  tr: monthNamesTurkish,
  'tr-TR': monthNamesTurkish,
  da: monthNamesDanish,
  'da-DA': monthNamesDanish,
  sv: monthNamesSweden,
  'sv-SE': monthNamesSweden
};

function getMonthsNameByLanguage(language) {
  return monthNamesByLanguage[language] || monthNamesEnglish;
}

var USER_PROFILE_KEY_IN_MAP = 'profile';

var placeholderReplacementsMap = _defineProperty$1({
  '{linebreak}': linebreakPlaceholder,
  '{br}': linebreakPlaceholder,
  '{year}': yearPlaceholder,
  '{month}': monthPlaceholder,
  '{day}': dayPlaceholder,
  '{short-month}': shortMonthPlaceholder,
  '{geo-country}': geoCountryPlaceholder,
  '{geo-city}': geoCityPlaceholder,
  '{geo-region}': geoRegionPlaceholder,
  '{geo-postal-code}': geoPostalCodePlaceholder,
  '{geo-state}': geoStatePlaceholder,
  '{downloadspeed}': localizationDownloadSpeedPlaceholder,
  '{price}': localizationPricePlaceholder,
  '{product-name}': localizationProductNamePlaceholder
}, "'{".concat(USER_PROFILE_KEY_IN_MAP, "}'"), getFromUserProfile);

var placeholderReplacementsTextStyleMap = {
  '{{bold}}': '<strong>',
  '{{/bold}}': '</strong>',
  '{{highlight}}': '<span class="highlighted-text" data-role="highlighted-text">',
  '{{/highlight}}': '</span>'
};

function linebreakPlaceholder() {
  return '<br />';
}

function yearPlaceholder() {
  return new Date().getFullYear();
}

function monthPlaceholder(text, commonGeo, language) {
  var monthNum = new Date().getMonth();
  var monthNamesArray = getMonthsNameByLanguage(language);
  return monthNamesArray[monthNum];
}

function dayPlaceholder() {
  return new Date().getDate();
}

function shortMonthPlaceholder(text, commonGeo, language) {
  var monthName = monthPlaceholder(text, commonGeo, language);
  return monthName.slice(0, 3);
}

function geoCountryPlaceholder(text, commonGeo) {
  var _commonGeo$country;

  var country = (_commonGeo$country = commonGeo === null || commonGeo === void 0 ? void 0 : commonGeo.country) !== null && _commonGeo$country !== void 0 ? _commonGeo$country : '';
  return countryMap[country] || country;
}

function geoCityPlaceholder(text, commonGeo) {
  var _commonGeo$city;

  return (_commonGeo$city = commonGeo === null || commonGeo === void 0 ? void 0 : commonGeo.city) !== null && _commonGeo$city !== void 0 ? _commonGeo$city : '';
}

function geoRegionPlaceholder(text, commonGeo) {
  var _commonGeo$region;

  return (_commonGeo$region = commonGeo === null || commonGeo === void 0 ? void 0 : commonGeo.region) !== null && _commonGeo$region !== void 0 ? _commonGeo$region : '';
}

function geoStatePlaceholder(text, commonGeo) {
  var _commonGeo$state;

  return (_commonGeo$state = commonGeo === null || commonGeo === void 0 ? void 0 : commonGeo.state) !== null && _commonGeo$state !== void 0 ? _commonGeo$state : '';
}

function geoPostalCodePlaceholder(text, commonGeo) {
  var _commonGeo$postal_cod;

  return (_commonGeo$postal_cod = commonGeo === null || commonGeo === void 0 ? void 0 : commonGeo['postal_code']) !== null && _commonGeo$postal_cod !== void 0 ? _commonGeo$postal_cod : '';
}

function localizationPricePlaceholder(text, commonGeo, language, localizationApiReplaceHolder) {
  var _localizationApiRepla;

  return (_localizationApiRepla = localizationApiReplaceHolder === null || localizationApiReplaceHolder === void 0 ? void 0 : localizationApiReplaceHolder.price) !== null && _localizationApiRepla !== void 0 ? _localizationApiRepla : '';
}

function localizationProductNamePlaceholder(text, commonGeo, language, localizationApiReplaceHolder) {
  var _localizationApiRepla2;

  return (_localizationApiRepla2 = localizationApiReplaceHolder === null || localizationApiReplaceHolder === void 0 ? void 0 : localizationApiReplaceHolder.productName) !== null && _localizationApiRepla2 !== void 0 ? _localizationApiRepla2 : '';
}

function localizationDownloadSpeedPlaceholder(text, commonGeo, language, localizationApiReplaceHolder) {
  var _localizationApiRepla3;

  return (_localizationApiRepla3 = localizationApiReplaceHolder === null || localizationApiReplaceHolder === void 0 ? void 0 : localizationApiReplaceHolder.downloadSpeed) !== null && _localizationApiRepla3 !== void 0 ? _localizationApiRepla3 : '';
}

function getFromUserProfile(text, commonGeo, language, localizationApiReplaceHolder, userProfileObject, userProfileKey) {
  var _userProfileObject$us;

  return (_userProfileObject$us = userProfileObject === null || userProfileObject === void 0 ? void 0 : userProfileObject[userProfileKey]) !== null && _userProfileObject$us !== void 0 ? _userProfileObject$us : '';
}

var styleTagsPlaceholderReplace = function styleTagsPlaceholderReplace(text) {
  var formattedText = text === null || text === void 0 ? void 0 : text.replace(/({{.+?}})/g, function (value) {
    return value.toLowerCase();
  });
  var params = Object.keys(placeholderReplacementsTextStyleMap);

  for (var _i = 0, _params = params; _i < _params.length; _i++) {
    var _formattedText;

    var param = _params[_i];
    var regex = new RegExp(param, 'g');
    formattedText = (_formattedText = formattedText) === null || _formattedText === void 0 ? void 0 : _formattedText.replace(regex, placeholderReplacementsTextStyleMap[param]);
  }

  return formattedText;
};

var PlaceholderTextReplace = function PlaceholderTextReplace(_ref) {
  var _ref2;

  var text = _ref.text,
      _ref$commonGeo = _ref.commonGeo,
      commonGeo = _ref$commonGeo === void 0 ? {} : _ref$commonGeo,
      _ref$userProfile = _ref.userProfile,
      userProfile = _ref$userProfile === void 0 ? {} : _ref$userProfile,
      className = _ref.className,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      hook = _ref.hook,
      testId = _ref.testId,
      language = _ref.language,
      localizationApiDynamicProductAttributes = _ref.localizationApiDynamicProductAttributes,
      _ref$additionalPlaceh = _ref.additionalPlaceholderReplacementsMap,
      additionalPlaceholderReplacementsMap = _ref$additionalPlaceh === void 0 ? {} : _ref$additionalPlaceh;

  var _useTranslation = useTranslation(),
      i18n = _useTranslation.i18n;

  var currLang = (_ref2 = language !== null && language !== void 0 ? language : i18n === null || i18n === void 0 ? void 0 : i18n.language) !== null && _ref2 !== void 0 ? _ref2 : i18next.language;
  var textWithStyleTagsReplaced = styleTagsPlaceholderReplace(text);
  var replacedText = replacePlaceholders(textWithStyleTagsReplaced, commonGeo, currLang, localizationApiDynamicProductAttributes, additionalPlaceholderReplacementsMap, userProfile);
  return /*#__PURE__*/React.createElement(Fragment, null, text && /*#__PURE__*/React.createElement(HTML, {
    as: as,
    className: className,
    hook: hook,
    testId: testId
  }, replacedText));
};

var isUserProfileKey = function isUserProfileKey(key, userProfile) {
  return key in userProfile;
};

function replacePlaceholders(text, commonGeo, language, localizationApiDynamicProductAttributes, additionalPlaceholderReplacementsMap, userProfile) {
  var _text;

  var unifiedPlaceholderReplacementMap = _objectSpread2(_objectSpread2({}, placeholderReplacementsMap), additionalPlaceholderReplacementsMap);

  var findTextInCurlyBracesRegex = /{([^}]+)}/g;
  var matches = ((_text = text) === null || _text === void 0 ? void 0 : _text.match(findTextInCurlyBracesRegex)) || [];

  var _iterator = _createForOfIteratorHelper(matches),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var match = _step.value;
      var replacedVal = '';
      var matchWithoutCurlyBraces = match.replace(/{|}/g, '');

      var _matchWithoutCurlyBra = matchWithoutCurlyBraces.split(','),
          _matchWithoutCurlyBra2 = _slicedToArray(_matchWithoutCurlyBra, 2),
          placeholderKey = _matchWithoutCurlyBra2[0],
          _matchWithoutCurlyBra3 = _matchWithoutCurlyBra2[1],
          fallbackVal = _matchWithoutCurlyBra3 === void 0 ? '' : _matchWithoutCurlyBra3;

      var transformedPlaceholderKey = "{".concat(placeholderKey.toLowerCase(), "}");
      var isUserProfile = userProfile ? isUserProfileKey(placeholderKey, userProfile) : false;

      if (unifiedPlaceholderReplacementMap !== null && unifiedPlaceholderReplacementMap !== void 0 && unifiedPlaceholderReplacementMap[transformedPlaceholderKey]) {
        replacedVal = unifiedPlaceholderReplacementMap[transformedPlaceholderKey](text, commonGeo, language, localizationApiDynamicProductAttributes);
      }

      if (isUserProfile) {
        replacedVal = unifiedPlaceholderReplacementMap["'{".concat(USER_PROFILE_KEY_IN_MAP, "}'")](text, commonGeo, language, localizationApiDynamicProductAttributes, userProfile, placeholderKey);
      }

      if (replacedVal === '') {
        replacedVal = fallbackVal ? fallbackVal : transformedPlaceholderKey;
      }

      text = text.replace("{".concat(matchWithoutCurlyBraces, "}"), replacedVal);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return text;
}

var _excluded = ["featuresIdentifiersMap", "productFeatureValues", "additionalPlaceholderReplacementsMap"];
var PlaceholdersTextReplaceWithFeatures = function PlaceholdersTextReplaceWithFeatures(props) {
  var featuresIdentifiersMap = props.featuresIdentifiersMap,
      productFeatureValues = props.productFeatureValues,
      additionalPlaceholderReplacementsMap = props.additionalPlaceholderReplacementsMap,
      placeholderTextReplaceProps = _objectWithoutProperties(props, _excluded);

  var replacementsMap = buildFeaturesReplacementMap(featuresIdentifiersMap, productFeatureValues);

  var additionalPlaceholderReplacementsMapWithFeaturesReplacement = _objectSpread2(_objectSpread2({}, additionalPlaceholderReplacementsMap), replacementsMap);

  return /*#__PURE__*/React.createElement(PlaceholderTextReplace, _extends({}, placeholderTextReplaceProps, {
    additionalPlaceholderReplacementsMap: additionalPlaceholderReplacementsMapWithFeaturesReplacement
  }));
};

export { PlaceholderTextReplace, PlaceholdersTextReplaceWithFeatures, replacePlaceholders, styleTagsPlaceholderReplace };
